import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Claim.SetStatusPayed.IRequest;
type Response = Api.Core.Claim.SetStatusPayed.IResponse;
type Headers = Api.Core.Claim.SetStatusPayed.IHeaders;
const url = '/api/Claims/Claim/:id/SetStatusPayed';
export default async function claimSetStatusPayedApi({ id }: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    url: createPathFromRoute(url, { id }, null),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
